// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Fetch Result Response Model
*/
export class EServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel {
    /**
    * @description Generic Result object that can represent any Service\\\'s result
    */
    'result'?: object | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel>> = [
        {
            "name":     "result",
            "baseName": "result",
            "type":     "object"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel.attributeTypeMap;
    }
}
